import Vue from 'vue';
import VueMeta from 'vue-meta';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import Loading from '@/plugins/vue-loading-overlay';
import VueLazyload from '@/plugins/vue-lazyload';
// import VueAnalytics from '@/plugins/vue-analytics';
import VueAnalytics from 'vue-analytics';
import Toasted from '@/plugins/toasted';
import { VueMasonryPlugin } from 'vue-masonry';
import axios from '@/axios';
import router from './router';
import store from './store';
import App from './App.vue';

// filter
import currencyFilter from './filters/currency';
import dateFilter from './filters/date';

// Vue.use(Loading);
Vue.use(VueMeta);
Vue.use(VueMasonryPlugin);
Vue.use(VueAnalytics, {
  id: 'UA-161618598-1',
  router,
});

// filter
Vue.filter('currency', currencyFilter);
Vue.filter('date', dateFilter);

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  axios,
  Toasted,
  VueLazyload,
  VueAnalytics,
  render: (h) => h(App),
}).$mount('#app');
